import React, { useState } from 'react';
import { Clock, Star, Users, Filter, Calendar, Check } from 'lucide-react';
import strings from '../../data/interactiveServices.json';
import './style.css';

// Простой хелпер переводов
const useT = (lang = 'en') => (path, fallback) =>
  path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), strings[lang]) ?? fallback;

const InteractiveServicesDemo = ({ lang = 'en' }) => {
  const t = useT(lang);

  // Данные берём из переводов
  const servicesData = t('services', []);
  const categoryNames = t('categories', { all: 'All', design: 'Design', development: 'Development', marketing: 'Marketing' });

  const [selectedCategory, setSelectedCategory] = useState('all');
  const [bookedServices, setBookedServices] = useState(new Set());
  const [favorites, setFavorites] = useState(new Set());

  const categories = [
    { id: 'all', name: categoryNames.all, count: servicesData.length },
    { id: 'design', name: categoryNames.design, count: servicesData.filter(s => s.category === 'design').length },
    { id: 'development', name: categoryNames.development, count: servicesData.filter(s => s.category === 'development').length },
    { id: 'marketing', name: categoryNames.marketing, count: servicesData.filter(s => s.category === 'marketing').length }
  ];

  const filteredServices = selectedCategory === 'all'
    ? servicesData
    : servicesData.filter(service => service.category === selectedCategory);

  const handleBook = (serviceId) => {
    setBookedServices(prev => {
      const next = new Set(prev);
      next.add(serviceId);
      return next;
    });

    // Авто-сброс через 3 сек (без "устаревшего" стейта)
    setTimeout(() => {
      setBookedServices(prev => {
        const next = new Set(prev);
        next.delete(serviceId);
        return next;
      });
    }, 3000);
  };

  const toggleFavorite = (serviceId) => {
    setFavorites(prev => {
      const next = new Set(prev);
      next.has(serviceId) ? next.delete(serviceId) : next.add(serviceId);
      return next;
    });
  };

  return (
    <div className="interactive-services">
      {/* Фильтры */}
      <div className="services-filters">
        <Filter size={14} />
        <div className="filter-buttons">
          {categories.map(category => (
            <button
              key={category.id}
              className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.id)}
            >
              {category.name}
              <span className="filter-count">{category.count}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Список услуг */}
      <div className="services-grid__card">
        {filteredServices.map((service) => (
          <div key={service.id} className="interactive-service-card">
            {service.popular && (
              <div className="service-badge popular">{t('badges.popular')}</div>
            )}

            <button
              className={`favorite-btn ${favorites.has(service.id) ? 'favorited' : ''}`}
              onClick={() => toggleFavorite(service.id)}
              aria-label="Toggle favorite"
            >
              <Star size={12} fill={favorites.has(service.id) ? 'currentColor' : 'none'} />
            </button>

            <div className="service-header">
              <h4 className="service-title__card">{service.name}</h4>
              <div className="service-rating" aria-label={`Rating ${service.rating}`}>
                <Star size={12} fill="currentColor" />
                <span>{service.rating}</span>
              </div>
            </div>

            <p className="service-description">{service.description}</p>

            <div className="service-stats">
              <div className="stat">
                <Clock size={12} />
                <span>{service.duration}</span>
              </div>
              <div className="stat">
                <Users size={12} />
                <span>{service.clients} {t('labels.clients')}</span>
              </div>
            </div>

            <div className="service-footer">
              <div className="service-price">{service.price}</div>
              <button
                className={`book-btn ${bookedServices.has(service.id) ? 'booked' : ''}`}
                onClick={() => handleBook(service.id)}
                disabled={bookedServices.has(service.id)}
              >
                {bookedServices.has(service.id) ? (
                  <>
                    <Check size={14} />
                    {t('buttons.requested')}
                  </>
                ) : (
                  <>
                    <Calendar size={14} />
                    {t('buttons.order')}
                  </>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="services-summary">
        {t('labels.shown')}:{' '}
        {filteredServices.length} {t('labels.of')} {servicesData.length} {t('labels.services')}
      </div>
    </div>
  );
};

export default InteractiveServicesDemo;
